import { Spin } from 'antd';

interface LoadingSpinnerProps {
  size?: 'small' | 'default' | 'large';
  tip?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'default',
  tip = 'Loading...',
}) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '16px',
    }}
  >
    <Spin size={size} tip={tip}>
      <div
        style={{
          padding: '50px',
          textAlign: 'center',
          background: 'transparent',
        }}
      >
        {/* This div is required for the nested pattern to work */}
      </div>
    </Spin>
  </div>
);
